exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".products-select[data-v-1fe5081c]{display:-webkit-box;display:-ms-flexbox;display:flex}.products-select__category[data-v-1fe5081c]{max-width:14rem;margin-right:.5rem}.products-select__product[data-v-1fe5081c]{max-width:32rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fe5081c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ProductsSelectComponent.vue
// module id = fNqC
// module chunks = 0